import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Plane, Route, Sun, Briefcase, Heart, ArrowRight, Phone } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import SEO from "../components/SEO";

const ICONS = { MapPin, Plane, Route, Sun, Briefcase, Heart };

const Services = () => {
  const { t } = useLang();
  return (
    <>
      <SEO title={t.seo.services.title} description={t.seo.services.description} keywords={t.seo.services.keywords} path="/services" />

      <section className="relative pt-32 pb-20 md:pt-40 md:pb-28 bg-cream overflow-hidden">
        <div className="absolute top-10 right-10 w-40 h-40 checkered-fine opacity-20" />
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 anim-fade-up relative">
          <div className="bt-tag mb-5">Brothers Taxi</div>
          <h1 className="font-display text-5xl md:text-6xl lg:text-7xl font-black uppercase tracking-tighter text-zinc-900 max-w-4xl">
            <span className="font-serif italic font-normal normal-case text-zinc-600 block mb-2">{t.accents.whateverNeeded}</span>
            {t.services.title}
          </h1>
          <p className="mt-6 text-zinc-600 text-xl max-w-3xl">{t.services.subtitle}</p>
        </div>
      </section>

      <section className="bg-paper py-20">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {t.services.items.map((s, i) => {
              const Icon = ICONS[s.icon] || MapPin;
              return (
                <div
                  key={i}
                  data-testid={`service-card-${i}`}
                  className={`group rounded-3xl p-7 border border-zinc-200 shadow-taxi-card hover:shadow-taxi-hover hover:-translate-y-1.5 transition-all ${
                    i % 4 === 0 ? "bg-zinc-900 text-white" : i % 3 === 1 ? "bg-[#FFD500]" : "bg-white"
                  }`}
                >
                  <div className={`h-14 w-14 rounded-2xl flex items-center justify-center mb-5 group-hover:rotate-[-8deg] transition-transform ${
                    i % 4 === 0 ? "bg-[#FFD500]" : "bg-zinc-900"
                  }`}>
                    <Icon className={`h-7 w-7 ${i % 4 === 0 ? "text-zinc-900" : "text-[#FFD500]"}`} strokeWidth={2.2} />
                  </div>
                  <h3 className={`font-display text-2xl font-black uppercase mb-3 tracking-tight ${i % 4 === 0 ? "text-white" : "text-zinc-900"}`}>
                    {s.name}
                  </h3>
                  <p className={`leading-relaxed ${i % 4 === 0 ? "text-zinc-300" : "text-zinc-700"}`}>{s.desc}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <section className="py-20 bg-mist">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 text-center">
          <h3 className="font-display text-3xl md:text-5xl font-black uppercase text-zinc-900 mb-6 tracking-tighter">{t.home.ctaBlockTitle}</h3>
          <p className="text-zinc-600 mb-8 text-lg">{t.home.ctaBlockSubtitle}</p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Link to="/book" className="bt-btn-primary">{t.common.bookTaxi} <ArrowRight className="h-4 w-4" /></Link>
            <a href="tel:+355682222286" className="bt-btn-outline"><Phone className="h-4 w-4" /> +355 68 22 22 286</a>
          </div>
        </div>
      </section>
    </>
  );
};

export default Services;
